module.exports = {
  local: {
    baseUrl: 'https://edg-test-api.ediangong.com:8201',
    mockUrl: 'https://api.xwhx.top',
    dist: 'signup-test2/',
    // bucket: 'edg-app',
    bucket: 'edg-app',
    appid: 'wx6c2349ffd522809f'
  },
  development: {
    baseUrl: 'https://edg-test-api.ediangong.com:8201',
    // baseUrl: 'https://customer.ediangong.com:8202',
    mockUrl: 'https://api.xwhx.top',
    dist: 'signup3/',
    bucket: 'edg-product-out',
    // appid: 'wxb831c1d402409aed'
    appid: 'wx6c2349ffd522809f'
    // appid:'wx6c2349ffd522809f'
  },
  production: {
    baseUrl: 'https://customer.ediangong.com:8202',
    // baseUrl: 'https://edg-test-api.ediangong.com:8201',
    mockUrl: 'https://api.xwhx.top',
    dist: 'signup2/',
    bucket: 'edg-app',
    appid: 'wx6c2349ffd522809f'
  },
  publish: {
    baseUrl: 'https://api.xwhx.top',
    mockUrl: 'https://api.xwhx.top',
    dist: 'signup/',
    bucket: 'edg-product-out'
  }
}
// BASE_URL: "https://edg-test-api.ediangong.com:8201",
// BASE_URL: "https://customer.ediangong.com:8202"
